var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObjectLaptopCritical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.25,
    y: 2.17603,
    width: 52,
    height: 53,
    rx: 6.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.25,
    y: 2.17603,
    width: 52,
    height: 53,
    rx: 6.5,
    stroke: "#FF8027",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9166 30.976V16.176H16.5833V30.976L13.25 41.176H43.25L39.9166 30.976ZM18.4666 18.0594H38.05V30.976H18.4666V18.0594ZM17.9333 32.8427H38.5833L40.6666 39.3094H15.85L17.9333 32.8427ZM32.75 35.7927L33.25 37.8427H23.25L23.9833 35.7927H32.75Z",
    fill: "#FF8027"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjectLaptopCritical);
export default __webpack_public_path__ + "static/media/object-laptop-critical.a12961c19593b56d82258cfe4aac8fa6.svg";
export { ForwardRef as ReactComponent };